import React from 'react';
import { Paper, Typography, Stack, Button, Box, useTheme } from '@mui/material';
import { CleaningServices, Home as HomeIcon, MenuBook } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { useInvalidateNavigationCache } from '../../hooks/settings/useInvalidateNavigationCache';
import { useInvalidateHomeCache } from '../../hooks/settings/useInvalidateHomeCache';

const CacheInvalidateButtons = ({ variant = 'card' }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const theme = useTheme();

    const navMutation = useInvalidateNavigationCache();
    const homeMutation = useInvalidateHomeCache();

    const buttons = (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <Button
                variant="outlined"
                color="inherit"
                startIcon={<MenuBook />}
                onClick={() => navMutation.mutate()}
                disabled={navMutation.isPending}
            >
                {isArabic ? 'تفريغ كاش التنقل' : 'Invalidate navigation cache'}
            </Button>
            <Button
                variant="outlined"
                color="inherit"
                startIcon={<HomeIcon />}
                onClick={() => homeMutation.mutate()}
                disabled={homeMutation.isPending}
            >
                {isArabic ? 'تفريغ كاش الصفحة الرئيسية' : 'Invalidate home cache'}
            </Button>
        </Stack>
    );

    if (variant === 'inline') {
        return buttons;
    }

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, md: 3 },
                borderRadius: 3,
                border: `1px solid ${theme.palette.divider}`,
                mb: 3,
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'warning.lighter',
                        color: 'warning.main',
                    }}
                >
                    <CleaningServices fontSize="small" />
                </Box>
                <Typography variant="h6" fontWeight={700}>
                    {isArabic ? 'كاش الواجهة الأمامية' : 'Storefront cache'}
                </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary" mb={2}>
                {isArabic
                    ? 'استخدم هذه الأزرار بعد تعديل قائمة التنقل أو محتوى الصفحة الرئيسية حتى تظهر التغييرات للزائرين فوراً.'
                    : 'Use these buttons after editing navigation or home page content so storefront visitors see the changes immediately.'}
            </Typography>
            {buttons}
        </Paper>
    );
};

export default CacheInvalidateButtons;
